import '../Social/Social.scss'



const Social = (props) =>{
    return(
        <>
            <div className="social__wrap">
                <a className="social__wrap-item" href="https://www.facebook.com/" target='_blank'>
                    <img  src="/img/facebook.png" alt="facebook" />
                </a>
                <a className="social__wrap-item" href="https://www.dribbble.com/" target='_blank'>
                    <img  src="/img/dribbble.png" alt="dribbble" />
                </a>
                <a className="social__wrap-item" href="https://www.twitter.com/" target='_blank'>
                    <img  src="/img/twitter.png" alt="dtwitter" />
                </a>
                <a className="social__wrap-item" href="mailto:mail@gmail.com" target='_blank'>
                    <img  src="/img/mail.png" alt="mail" />
                </a>
                <a className="social__wrap-item" href="https://www.vimeo.com/" target='_blank'>
                    <img  src="/img/vimeo.png" alt="vimeo" />
                </a>
            </div>
        </>
    )
}

export default Social;  